import pluralize from "pluralize";
import {ReactNode, useState} from "react";
import {FiTrash} from "react-icons/fi";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {TableCrownButton} from "@/components/tableCrownButton/TableCrownButton.tsx";

interface BulkDeleteCrownActionProps {
  selectedItems: Record<string, boolean>;
  setSelectedItems: (selectedItems: Record<string, boolean>) => void;
  title: string;
  itemLabel: string;
  buttonLabel?: ReactNode;
  loading?: boolean;
  onDelete: (ids: string[]) => Promise<unknown>;
}

export const BulkDeleteCrownAction = ({
  selectedItems,
  setSelectedItems,
  title,
  itemLabel,
  buttonLabel = "Delete",
  loading,
  onDelete,
}: BulkDeleteCrownActionProps) => {
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const ids = Object.keys(selectedItems);
  const disabled = ids.length === 0;

  return (
    <>
      <TableCrownButton disabled={disabled} onClick={() => setShowDelete(true)}>
        <Icon icon={FiTrash} />
        {buttonLabel}
      </TableCrownButton>
      <DeleteActionDialog
        show={showDelete}
        loading={loading}
        title={title}
        disableConfirmButton={disabled}
        onConfirm={async () => {
          await onDelete(ids);
          setSelectedItems({});
          setShowDelete(false);
        }}
        onCancel={() => {
          setShowDelete(false);
        }}
      >
        Are you sure you want to delete {ids.length} {pluralize(itemLabel, ids.length)}?
      </DeleteActionDialog>
    </>
  );
};
